var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFota(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 115,
    viewBox: "0 0 144 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.587 36.6435L113.587 36.6441C113.709 38.2087 114.946 39.4566 116.514 39.5949C127.612 40.5758 136.306 50.0235 136.306 61.097C136.306 73.0304 126.551 82.7456 114.557 82.7456C112.781 82.7456 111.337 84.1803 111.337 85.9539C111.337 87.7275 112.781 89.1622 114.557 89.1622H114.56C130.101 89.1622 142.749 76.5753 142.749 61.097C142.749 47.6038 132.819 35.9891 119.703 33.5601C117.264 18.4127 103.954 6.89853 88.3119 6.89853C84.4256 6.89853 80.4714 7.66523 76.9632 9.07717C70.5441 4.16196 62.6039 1.47949 54.3804 1.47949C35.0372 1.47949 18.7805 16.6179 17.1876 35.646C7.27578 40.2105 0.746094 50.1809 0.746094 61.097C0.746094 76.5726 13.3203 89.1622 28.7758 89.1622C30.5519 89.1622 31.996 87.7275 31.996 85.9539C31.996 84.1803 30.5519 82.7456 28.7758 82.7456C16.8736 82.7456 7.18893 73.0339 7.18893 61.097C7.18893 52.1447 12.9044 43.9975 21.4178 40.8394L21.4185 40.8392C22.6474 40.3814 23.48 39.2259 23.5148 37.9168L23.5148 37.9165C23.9456 21.3686 37.7986 7.89853 54.3828 7.89853C61.878 7.89853 68.7847 10.4387 74.3626 15.2423L74.3631 15.2427C75.3512 16.0913 76.7491 16.2685 77.9117 15.6856C80.9715 14.1589 84.6687 13.3151 88.3119 13.3151C101.487 13.3151 112.587 23.5663 113.587 36.6435Z",
    fill: "url(#paint0_linear_727_3350)",
    stroke: "url(#paint1_linear_727_3350)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4837 106.69H91.673C90.8066 106.69 89.9369 106.342 89.3042 105.652C88.0992 104.348 88.1836 102.319 89.4932 101.119L89.4933 101.119C94.6444 96.4013 97.6267 89.961 97.8931 82.9803L97.8932 82.98C98.1644 75.9845 95.6857 69.3317 90.9143 64.2395L90.9116 64.2365L90.9116 64.2365C84.5658 57.3547 74.9034 54.4132 65.6816 56.5681C63.9545 56.9952 62.2173 55.8966 61.8076 54.1789L61.8072 54.1774C61.4011 52.4505 62.4775 50.7231 64.2084 50.3197M92.4837 106.69L64.2084 50.3197M92.4837 106.69L92.4355 106.594C92.9478 106.47 93.4367 106.219 93.8511 105.838C100.273 99.9557 103.995 91.9221 104.33 83.2208C104.666 74.5128 101.572 66.2121 95.6401 59.8747C87.7303 51.3051 75.6995 47.6394 64.2084 50.3197M92.4837 106.69L64.3219 50.8066L64.2084 50.3197",
    fill: "url(#paint2_linear_727_3350)",
    stroke: "url(#paint3_linear_727_3350)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4787 103.892L88.4788 103.893C88.6905 105.513 90.0758 106.691 91.6703 106.691C91.8056 106.691 91.9466 106.682 92.0832 106.665L92.0842 106.665C93.8448 106.437 95.0961 104.832 94.8667 103.072L93.585 93.1936L93.5849 93.1927C93.3522 91.4235 91.6914 90.2081 89.9817 90.4212L89.9817 90.4212L89.9795 90.4215C88.219 90.6489 86.9677 92.2535 87.1969 94.0139C87.1969 94.014 87.1969 94.0141 87.197 94.0142L88.4787 103.892Z",
    fill: "url(#paint4_linear_727_3350)",
    stroke: "url(#paint5_linear_727_3350)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4847 103.944L88.4849 103.945C88.7198 105.542 90.0965 106.691 91.6704 106.691C91.8183 106.691 91.9752 106.682 92.1365 106.659C92.1367 106.659 92.137 106.659 92.1372 106.659L102.058 105.227L102.058 105.227C103.813 104.97 105.038 103.348 104.783 101.589L104.783 101.588C104.528 99.8412 102.891 98.6094 101.13 98.8741C101.13 98.8742 101.129 98.8743 101.129 98.8744L91.21 100.306L91.2092 100.306C89.4541 100.562 88.2294 102.185 88.4847 103.944Z",
    fill: "url(#paint6_linear_727_3350)",
    stroke: "url(#paint7_linear_727_3350)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7978 114.479H72.2978V114.473C74.6227 114.438 76.9642 114.156 79.284 113.616L79.2842 113.616C81.015 113.213 82.0914 111.486 81.6853 109.759L81.6851 109.758C81.2754 108.028 79.5517 106.982 77.8198 107.366L77.815 107.367C68.5718 109.512 58.9272 106.577 52.5808 99.6993L52.5782 99.6965C47.8214 94.6212 45.3373 87.9775 45.5774 80.983C45.8224 73.9887 48.7623 67.5363 53.8574 62.8052L53.8575 62.8051C55.1585 61.5963 55.2311 59.5669 54.0169 58.2686L54.0169 58.2685C52.7986 56.9663 50.7611 56.9021 49.466 58.1098C43.1107 64.0119 39.4431 72.058 39.1401 80.7633L39.1401 80.7634C38.8395 89.4632 41.94 97.7437 47.8524 104.061C54.0503 110.778 62.7851 114.479 71.7978 114.479Z",
    fill: "url(#paint8_linear_727_3350)",
    stroke: "url(#paint9_linear_727_3350)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9129 70.8017L49.913 70.8023C50.148 72.3996 51.5274 73.5481 53.0985 73.5481C53.2464 73.5481 53.4034 73.5398 53.5648 73.5161C55.3202 73.2597 56.5444 71.6321 56.289 69.8781L56.289 69.878L54.8482 59.9995L54.8481 59.9988C54.5902 58.2477 52.9448 57.026 51.1965 57.2851C49.441 57.5414 48.2167 59.169 48.4721 60.9231L48.4721 60.9232L49.9129 70.8017Z",
    fill: "url(#paint10_linear_727_3350)",
    stroke: "url(#paint11_linear_727_3350)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4287 58.7194C39.6695 58.9759 38.4509 60.6074 38.7119 62.361C38.9471 63.956 40.3242 65.1015 41.8949 65.1015C42.044 65.1015 42.2029 65.0933 42.3698 65.0664L52.1286 63.635C52.1287 63.6349 52.1289 63.6349 52.129 63.6349C53.888 63.3783 55.1065 61.7469 54.8456 59.9934C54.5883 58.245 52.9732 57.0089 51.1889 57.2877L41.4289 58.7193C41.4288 58.7194 41.4287 58.7194 41.4287 58.7194Z",
    fill: "url(#paint12_linear_727_3350)",
    stroke: "url(#paint13_linear_727_3350)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_727_3350",
    x1: 71.7473,
    y1: 1.97949,
    x2: 71.7473,
    y2: 88.6622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_727_3350",
    x1: 71.7473,
    y1: 1.97949,
    x2: 71.7473,
    y2: 88.6622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_727_3350",
    x1: 83.0383,
    y1: 49.9565,
    x2: 83.0383,
    y2: 106.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_727_3350",
    x1: 83.0383,
    y1: 49.9565,
    x2: 83.0383,
    y2: 106.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_727_3350",
    x1: 91.0319,
    y1: 90.897,
    x2: 91.0319,
    y2: 106.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_727_3350",
    x1: 91.0319,
    y1: 90.897,
    x2: 91.0319,
    y2: 106.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_727_3350",
    x1: 96.6338,
    y1: 99.3384,
    x2: 96.6338,
    y2: 106.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_727_3350",
    x1: 96.6338,
    y1: 99.3384,
    x2: 96.6338,
    y2: 106.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_727_3350",
    x1: 60.4455,
    y1: 57.7461,
    x2: 60.4455,
    y2: 113.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_727_3350",
    x1: 60.4455,
    y1: 57.7461,
    x2: 60.4455,
    y2: 113.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_727_3350",
    x1: 52.3806,
    y1: 57.7505,
    x2: 52.3806,
    y2: 73.0481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_727_3350",
    x1: 52.3806,
    y1: 57.7505,
    x2: 52.3806,
    y2: 73.0481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_727_3350",
    x1: 46.7787,
    y1: 57.7485,
    x2: 46.7787,
    y2: 64.6015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_727_3350",
    x1: 46.7787,
    y1: 57.7485,
    x2: 46.7787,
    y2: 64.6015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFota);
export default __webpack_public_path__ + "static/media/fota.135a766690f2b2143af63cd2a0f75854.svg";
export { ForwardRef as ReactComponent };